import { registerBlockType } from '@wordpress/blocks';
import TriggerNotificationsBlock from './TriggerNotificationsBlock';
import { createRoot } from 'react-dom/client';
import './editor.css';

registerBlockType('wdm-ld-custom-reports/trigger-notifications', {
    title: 'Trigger Notifications',
    icon: 'bell',
    category: 'wisdm-learndash-reports',
    attributes: {
        selectedUser: { type: 'object', default: null },
        selectedCourse: { type: 'object', default: null },
        selectedTime: { type: 'object', default: { hours: 0, minutes: 0 } },
        notificationMessage: { type: 'object', default: null }
    },
    // Only static UI in edit
    edit: (props) => {
        return <TriggerNotificationsBlock {...props} isEditor={true} />;
    },
    // Save function to display the dynamic form on the frontend
    save: (props) => {
        return <div className="wdm-trigger-notifications-block-wrapper"></div>;
    }
});

// Add selector on the Trigger notifications block.
document.addEventListener( 'DOMContentLoaded', (event) => {
    let element  = document.getElementsByClassName('wdm-trigger-notifications-block-wrapper');
    if( element.length > 0 ) {
        let root = createRoot( element[0] );
        root.render(<TriggerNotificationsBlock container="wdm-learndash-reports-trigger-notifications"/>);
    }
});
